"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentSeriesSchemaDef = exports.examDateSchemaDef = exports.submissionWindowSchemaDef = void 0;
const joi_1 = __importDefault(require("joi"));
const series_1 = require("../db/series");
const schemaValidator_1 = require("../../util/schemaValidator");
exports.submissionWindowSchemaDef = {
    ...series_1.submissionWindowBaseSchemaDef,
    start: (0, series_1.dateSchema)().required(),
    end: (0, series_1.dateSchema)().required(),
};
exports.examDateSchemaDef = {
    date: (0, series_1.dateSchema)().required(),
    examTimeOfDay: joi_1.default.string().valid('AM', 'PM').required().allow(null),
    zone: joi_1.default.string().required().allow(null),
    zoneId: joi_1.default.string().required().allow(null),
};
exports.componentSeriesSchemaDef = {
    ...series_1.seriesBaseSchemaDef,
    examDates: (0, schemaValidator_1.arraySchema)(exports.examDateSchemaDef).default([]),
    submissionWindow: (0, schemaValidator_1.objectSchema)(exports.submissionWindowSchemaDef),
};
